import axios from "axios";

export const omgApiClient = axios.create({
  baseURL: import.meta.env.VITE_OMG_API_URL,
});
